export const Routes = {
  Home: '/',
  Login: '/login',
  CreateAccount: '/create-account',
  LeagueSync: '/fantasy/league-sync',
  MyLeagues: '/fantasy/leagues',
  MockDraftSimulator: '/fantasy/draft/mock-draft-simulator',
  LiveDraftAssistant: '/fantasy/draft/live-draft-assistant',
}
